// Note: not the side-nav index - that pulls in the side nav styles, which import field-row, which imports
// this file
import { SIDE_NAV_STICKY_TOP } from '@/components/layout/side-nav/side-nav.constants'

// Note: height of the sticky app navbar (`.navmgr`)
export const NAVBAR_HEIGHT = '56px'

// Note: same offset as the sticky side nav, so the stuck tab header lines up with the nav's top border
export const STICKY_TOP = `${SIDE_NAV_STICKY_TOP}px`

// Note: height of the sticky tab card header (title + actions), including its vertical padding
export const TAB_HEADER_HEIGHT = '48px'

// Note: group headers stick right under the sticky tab card header
export const GROUP_HEADER_TOP = `calc(${STICKY_TOP} + ${TAB_HEADER_HEIGHT})`
